<div class="modal-header">
    <h4 class="modal-title"
        id="modal-basic-title">{{'bikeshop.modal.select_technician.assign_a_technician' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span class="hubtiger-close"></span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-3 label">{{'bikeshop.modal.select_technician.select_a_technician' | translate}}:</div>
        <div class="col-lg-9">
            <p-dropdown [options]="technicians" [(ngModel)]="selectedTechnician"
                        placeholder="Select a technician..."></p-dropdown>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="col-md-9"></div>
    <div class="col-md-3">
        <button pButton type="button" class="p-button-raised full-width" (click)="modal.close(selectedTechnician)"
                label="{{'bikeshop.modal.select_technician.button.assign' | translate}}"
                [disabled]="!(selectedTechnician && selectedTechnician.ID)"></button>
    </div>
</div>
